import { FC } from 'react'

import styled from 'styled-components'
import { useForm } from 'react-hook-form'

import { Button } from 'src/Components/Button'
import { AddClientBody } from 'src/Redux/api/clientsApi.ts'
import { Modal } from 'src/Components/Modal'
import { Select } from 'src/Components/Select'
import { DatePicker } from 'src/Components/DatePicker/index.tsx'
import { Checkbox } from 'src/Components/Checkbox/index.tsx'

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 0;
  width: 100%;
`

const InputContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`

interface AddClientModalProps {
  onClose: () => void
  onAddClient: (client: AddClientBody) => void
  isOpened: boolean
}

export const SignContractModal: FC<AddClientModalProps> = ({
  isOpened,
  onClose,
  onAddClient,
}) => {
  const {
    control: _control,
    handleSubmit,

    formState: { errors: _errors },
    reset,
  } = useForm<AddClientBody>({
    defaultValues: {
      name: '',
      inn: '',
      director: '',
      legalAddress: '',
      phone: '',
      organizationalForm: '',
      ogrn: undefined,
      headPosition: '',
      kpp: '',
      rs: '',
      ks: '',
      bic: '',
      bankName: '',
      postAddress: '',
    },
  })

  const onSubmit = (data: AddClientBody): void => {
    onAddClient(data)
    reset()
    onClose()
  }

  return (
    <Modal
      opened={isOpened}
      onClose={onClose}
      title='Отправить на согласование'
    >
      <ModalContainer>
        <InputContainer>
          <Select
            label={'Должностное лицо'}
            data={[
              {
                label: 'Иванов',
                value: 'Иванов',
              },
              {
                label: 'Петров',
                value: 'Петров',
              },
            ]}
          />
          <DatePicker label={'Срок согласования'} />

          <Checkbox label={'Направить уведомление'} />
        </InputContainer>

        <InputContainer>
          <Select
            label={'Должностное лицо'}
            data={[
              {
                label: 'Иванов',
                value: 'Иванов',
              },
              {
                label: 'Петров',
                value: 'Петров',
              },
            ]}
          />
          <DatePicker label={'Срок согласования'} />

          <Checkbox label={'Направить уведомление'} />
        </InputContainer>

        <InputContainer>
          <Select
            label={'Должностное лицо'}
            data={[
              {
                label: 'Иванов',
                value: 'Иванов',
              },
              {
                label: 'Петров',
                value: 'Петров',
              },
            ]}
          />
          <DatePicker label={'Срок согласования'} />

          <Checkbox label={'Направить уведомление'} />
        </InputContainer>
      </ModalContainer>
      <ButtonContainer>
        <Button onClick={handleSubmit(onSubmit)}>Отправить контракт</Button>
        <Button onClick={handleSubmit(onSubmit)}>
          Контракт не требует согласования
        </Button>
      </ButtonContainer>
    </Modal>
  )
}
